var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-container",domProps:{"innerHTML":_vm._s(require(`!html-loader!../../styles/images/svg/${_vm.icon}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }